export default "__VITE_ASSET__CVhmb8Mj__"